import React from 'react'

const TotalizersPlaceholder = props => (
  <div className='extract-resume row bg-ui-5 border-bottom border-color-ui-3'>
    <div className='col-12 col-md-6 border-right border-left border-color-ui-3 py-2 px-3'>
      <div className='row'>
        <div className='col-12 row mb-1'>
          <div className='col-2 ml-1 py-half radius bg-ui-3 py-1' />
        </div>
        <div className='col-12'>
          <div className='row'>
            <div className='extract-item col-12'>
              <div className='row'>
                <div className='col-6 row mr-auto mb-1'>
                  <div className='col-12 ml-1 py-half radius bg-ui-3' />
                </div>
                <div className='col-6 row ml-auto mb-1'>
                  <div className='col-12 mr-1 py-half radius bg-ui-3' />
                </div>
                <div className='col-6 row mr-auto mb-1'>
                  <div className='col-12 ml-1 py-half radius bg-ui-3' />
                </div>
                <div className='col-6 row ml-auto mb-1'>
                  <div className='col-12 mr-1 py-half radius bg-ui-3' />
                </div>
                <div className='col-6 row mr-auto mb-1'>
                  <div className='col-6 ml-1 py-half radius bg-ui-3' />
                </div>
                <div className='col-6 row ml-auto mb-1'>
                  <div className='col-12 mr-1 py-half radius bg-ui-3' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='col-12 col-md-6 border-right border-left border-color-ui-3 py-2 px-3'>
      <div className='row'>
        <div className='col-12 row mb-1'>
          <div className='col-2 ml-1 py-half radius bg-ui-3 py-1' />
        </div>
        <div className='col-12'>
          <div className='row'>
            <div className='extract-item col-12'>
              <div className='row'>
                <div className='col-6 row mr-auto mb-1'>
                  <div className='col-12 ml-1 py-half radius bg-ui-3' />
                </div>
                <div className='col-6 row ml-auto mb-1'>
                  <div className='col-12 mr-1 py-half radius bg-ui-3' />
                </div>
                <div className='col-6 row mr-auto mb-1'>
                  <div className='col-12 ml-1 py-half radius bg-ui-3' />
                </div>
                <div className='col-6 row ml-auto mb-1'>
                  <div className='col-12 mr-1 py-half radius bg-ui-3' />
                </div>
                <div className='col-6 row mr-auto mb-1'>
                  <div className='col-6 ml-1 py-half radius bg-ui-3' />
                </div>
                <div className='col-6 row ml-auto mb-1'>
                  <div className='col-12 mr-1 py-half radius bg-ui-3' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default TotalizersPlaceholder



// WEBPACK FOOTER //
// ./src/Participant/Extract/Totalizers/TotalizersPlaceholder.js